<template>
  <v-dialog v-model="dialog" scrollable>
    <v-card class="pa-0">
      <v-card-title :class="editMode ? editColor : addColor">
        <span class="headline px-2">{{ title }}</span>
      </v-card-title>
      <v-card-text :class="editMode ? editColor : addColor">
        <v-container grid-list-xs>
          <MongoForm 
            ref="form"
            v-model="form"
            :defaultForm="defaultForm"
            :schema="service.schema"
            :discriminators="discriminators"
            :discriminatorKey="discriminatorKey"
            :readonly="readonly"
            :showDetails="!readonly"
          />
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="deletable && editMode && !readonly" color="red darken-1" flat @click.native="deleteDocument()" :loading="deleteLoading">
          Remove
        </v-btn>
        <v-btn v-if="editMode && !readonly && copyable" color="black" flat @click.native="copyDocument()" :loading="copyLoading">
          Make a copy
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" :round="editMode" dark @click.native="close()">Close</v-btn>
        <v-btn v-if="!readonly" :round="editMode" :dark="!editMode" :color="editMode ? editColor : addColor" @click.native="submit()" :loading="loading" large>{{ editMode ? 'Save' : 'Add' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import MessageDialog from '../../libs/message-dialog/'
  import MongoConnector from '../../services/mongo-connector.service'
  import MongoForm from './MongoForm'
  import { unflattenObject, parseFormInputValue } from '../../libs/utils'
  import { FIELD_ID } from '../../libs/mongo-datatable'

  export default {
    props: {
      value: { type: Object, required: false, default: () => ({}) },
      service: { type: MongoConnector, required: true },
      discriminators: { type: Object, required: false, default: null },
      discriminatorKey: { type: String, required: false, default: null },
      title: { type: String, required: false, default: 'Add new item' },
      editMode: { type: Boolean, required: false, default: false },
      copyable: { type: Boolean, required: false, default: false },
      readonly: { type: Boolean, required: false, default: false },
      deletable: { type: Boolean, required: false, default: true },
      onInsert: { type: Function, required: false, default: null },
      onEdit: { type: Function, required: false, default: null },
      onDelete: { type: Function, required: false, default: null }
    },
    data () {
      return {
        addColor: 'teal accent-3',
        editColor: 'amber',
        dialog: false,
        loading: false,
        form: {},
        defaultForm: {},
        deleteLoading: false,
        copyLoading: false
      }
    },
    watch: {
      dialog (val) {
        val ? this._open() : this._close()
      }
      // ,
      // form: {
      //   deep: true,
      //   handler (val) {
      //     this.$emit('input', val)
      //   }
      // }
    },
    methods: {
      open () {
        this.dialog = true
        this.$emit('open')
      },
      _open () {
        this.loading = false
        this.defaultForm = unflattenObject(
          Object.keys(this.value).reduce((c, key) => {
            c[key] = parseFormInputValue(this.service.schema[key], this.value[key])
            return c
          }, {})
        )
      },
      close () {
        this.dialog = false
        this.$emit('close')
      },
      _close () {
        this.$nextTick(() => this.$refs.form.reset())
      },
      async submit () {
        const valid = this.$refs.form.submit()
        if (valid) {
          await this.submitted()
        }
      },
      async submitted () {
        this.loading = true
        let response
        try {
          console.log(this.editMode ? 'Updated!' : 'Added!', this.form)
          if (this.editMode) {
            const { value } = await MessageDialog.showEditConfirmMessage()
            if (value && value !== '') {
              if (this.onEdit) {
                response = await this.onEdit(this.form, value)
              } else {
                response = await this.service.updateDocuments(this.form, value)
              }
            }
          } else {
            const { value } = await MessageDialog.showEditConfirmMessage({
              title: 'Adding new item',
              text: 'Please note the reason for adding',
              confirmButtonText: 'Yes, add it !!',
              cancelButtonText: 'Cancel'
            })
            if (value && value !== '') {
              if (this.onInsert) {
                response = await this.onInsert(this.form, value)
              } else {
                response = await this.service.insert(this.form, value)
              }
            }
          }
          if (response) {
            this.close()
            this.$emit('updated')
          }
        } catch (e) {
          console.error(e)
        }
        this.loading = false
      },
      async deleteDocument () {
        let response
        try {
          const { value } = await MessageDialog.showWarningMessage()
          if (value && value !== '') {
            this.deleteLoading = true
            if (this.onDelete) {
              response = await this.onDelete(this.form, value)
            } else {
              response = await this.service.deleteDocuments(this.form, value)
            }
            if (response) {
              this.close()
              this.$emit('updated')
            }
          }
        } catch (e) {
          console.error(e)
        }
        this.deleteLoading = false
      },
      async copyDocument () {
        try {
          const form = { ...this.form }
          delete form[FIELD_ID]
          this.$emit('copied', form)
        } catch (e) {
          console.error(e)
        }
        this.copyLoading = false
      }
    },
    components: {
      MongoForm
    }
  }
</script>
